import React from 'react';
import {Styles} from '../../../../../config/design/styles';
import { withStyles } from '@material-ui/core/styles';
import { withSnackbar } from 'notistack';
import withWidth from "@material-ui/core/withWidth/withWidth";
import {withRouter} from "react-router";
import {connect} from "trim-redux";
import axios from "axios";
import {defaultVariabls} from "../../../../../config";
import SingleStatusCard from "./SingleStatusCard";
import Grid from '@material-ui/core/Grid';

class TrackingProgress extends React.Component {
    state = {
        statuses: true,
        order: null,
        current:1,
        loading:true,
        transferType:this.props.transferType,
    };
    classes = this.props.classes;
    componentDidMount(){
        this.setState({
            current: this.props.current,
            transferType:this.props.transferType,
        })
        this.loadData();
    }
    async loadData(){
        let config = {
            headers: {
                Accept: 'application/json',
            }
        };
        await axios.get(`${defaultVariabls.url}/status/getAll`, config)
            .then(response => {
                // eslint-disable-next-line
                this.setState({
                    statuses: response.data,
                    loading:false,
                })
            })
            .catch(error => {
                console.log(error)
                this.setState({
                    loading:false
                })
            });
    }
    render(){
        let {loading,statuses,current} = this.state;
        return (
            <>
                {
                    loading ? null:
                        <Grid container spacing={2} justify="center" alignItems="center" >
                            {
                                statuses.map((status,item) => (
                                    <Grid item xs={4} md={3} lg={1} key={item}>
                                        <SingleStatusCard status={status} before={status.id<current} current={status.id===current} transferType={this.state.transferType}/>
                                    </Grid>
                                ))
                            }
                        </Grid>
                }

                </>
        );
    }
}
const mstp = state => ({
    locale: state.locale,
});
export default withWidth()(withSnackbar(withRouter(withStyles(Styles)(connect(mstp)(TrackingProgress)))));